import { ROUTES } from '@/app/routes';

/**
 * GERİ DÖNÜŞ ADRESİ (panel küçük işler 1 · B-02).
 *
 * Kapı oturumsuz personeli giriş ekranına götürürken bulunduğu adresi gezinme
 * DURUMUNDA taşır (adres çubuğunda değil: dışarıdan verilen bir bağlantı
 * dönüş hedefi seçemez). Giriş başarılı olunca personel kaldığı ekrana döner.
 *
 * Yalnız panelin kendi yolu kabul edilir, aksi hâlde kök:
 *  - `/` ile başlar, `//` ile başlamaz (protokolsüz dış adres), ters eğik
 *    çizgi taşımaz.
 *  - Denetim karakteri ve boşluk taşımaz. URL ayrıştırıcısı sekme ve satır
 *    sonunu SİLER: `/\t/evil` ayrıştırılınca `//evil` olur ve dış kökene
 *    çözülür (tech-lead saldırısı, öz-test `session-expiry-redirect.spec`).
 *  - Gözcü kökene göre ayrıştırılınca köken DEĞİŞMEZ. Dönen değer ayrıştırılmış
 *    biçimdir (`/./a` → `/a`), ham dize değil.
 *  - Giriş ya da kurulum ekranını göstermez. Karşılaştırma yönlendiricinin
 *    eşlediği biçimle yapılır: kod çözülmüş, küçük harf, sondaki `/` atılmış
 *    (`/Giris/`, `/%67iris`, `/./giris` de giriş ekranıdır). Giriş ekranına
 *    dönüş döngü olurdu.
 */
export interface ReturnState {
  readonly from: string;
}

const SENTINEL_ORIGIN = 'https://panel.invalid';
const LOOP_TARGETS: readonly string[] = [ROUTES.signIn, ROUTES.setup];

export function returnStateFor(pathname: string, search: string): ReturnState {
  return { from: `${pathname}${search}` };
}

export function safeReturnPath(state: unknown): string {
  if (typeof state !== 'object' || state === null || !('from' in state)) return ROUTES.home;
  const { from } = state;
  if (typeof from !== 'string') return ROUTES.home;
  if (!from.startsWith('/') || from.startsWith('//') || from.includes('\\')) return ROUTES.home;
  // eslint-disable-next-line no-control-regex
  if (/[\u0000- \u007f]/.test(from)) return ROUTES.home;

  let parsed: URL;
  try {
    parsed = new URL(from, SENTINEL_ORIGIN);
  } catch {
    return ROUTES.home;
  }
  if (parsed.origin !== SENTINEL_ORIGIN) return ROUTES.home;
  if (LOOP_TARGETS.includes(routeKey(parsed.pathname))) return ROUTES.home;
  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}

/** Yönlendiricinin eşlediği biçim: kod çözülmüş, küçük harf, sondaki `/` yok. */
function routeKey(pathname: string): string {
  let decoded: string;
  try {
    decoded = decodeURIComponent(pathname);
  } catch {
    decoded = pathname;
  }
  const lowered = decoded.toLowerCase();
  return lowered.length > 1 ? lowered.replace(/\/+$/, '') : lowered;
}
